import React from 'react';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom'
// import Routers from '../Pages/Routers'
import '../styles/main_global.css';
import Landing from '../Pages/Landing';
// import PrivateRouter from "./PrivateRouter";
// import PrivateRouteAdmin from "./PrivateRouteAdmin";

const MainRouter = () => (
    <BrowserRouter>
        <Switch>
            
            {/* #Landing route */}
            <Route exact path='/' component={Landing}/>
           


            {/*
            #Regular route for unauthorised user
            <Route path='/registration_rejected' component={RegistrationRejected}/>
            */}

            {/*
            #Route with optional param in url
            <Route path='/sign_in:route?' component={SignIn}/>*/}

            {/*
            #Private Route only for logged users with token
            <PrivateRouter path='/profile'/>
            */}


            {/*
            #Admin login route
            <Route exact path='/admin' component={Login}/>
            */}

            {/*
            #Private Route for logged users with two dynamic params in url (required params) (example: /create_dashboard/51/settings)
            <PrivateRouter path='/create_dashboard/:id/:route'/>
            */}


            {/*
            #Private route for logged admin users with token for admin pages
            <PrivateRouteAdmin path='/admin/:slug'/>
            */}


            {/*#Route to redirect on created /404 page*/}
            {/*<Route exact path='/404' component={Routers}/>*/}

            {/*#Redirect to /404 if link is incorrect*/}
            <Redirect to={'/404'}/>
        </Switch>
    </BrowserRouter>
);
export default MainRouter
